const ErrorOldBrowser = () => {
  return (
    <>
      <h1>Helaas...</h1>
      <p>Trefpunt werkt niet of niet goed op de browser die u momenteel gebruikt, update uw browser of installeer een andere.</p>
    </>
  );
}

export default ErrorOldBrowser;
